<template>
  <div class="full-screen">

    <router-link :to="`../../`" class="close"><span class="close__title">Esc</span></router-link>

    <div class="add-pharmacy-wrapper">

      <div class="pre-title">Копирование стеллажа</div>




      <div style="text-align: center">

          <select-material
                  :isMulti="false"
                  :title="`Аптека`"
                  :possibleValues="pharmacies"
                  @select="pharmacy = $event"
          ></select-material>

      </div>

      <div class="" style="text-align: center; margin-top: 50px;">

        <a href="#" @click.prevent="copy()" class="button">Копировать</a>

      </div>

    </div>




  </div>
</template>


<script type="text/javascript">
  import axios from 'axios';
  import selectMaterial from '../html/SelectMaterial';


  export default {
    name: 'rack-add',
    created() {
      this.loadPharmacies();
    },
    methods: {
      loadPharmacies() {
        const that = this;
        axios.get('/api/v2/pharmacies/').then((response) => {
          that.isLoading = false;
          this.pharmacies = response.data;
        });
      },
      copy() {
        const that = this;
        axios.post('/api/copyRack/', {
          rackId: this.$route.params.rack,
          toId: this.pharmacy,
          angle: 0,
          startX: 0,
          startY: 0,
        }).then(() => {
          that.$router.push('../../');
        });
      },
    },
    data() {
      return {
        pharmacy: '',
        pharmacies: [],
      };
    },
    components: { selectMaterial },
  };
</script>


<style type="text/css" lang="less" >





</style>


// WEBPACK FOOTER //
// CopyRack.vue?3762eb72